<template>
    <div class="card housekeeping-card position-relative">
        <div class="bg-blue-light p-1">
            <TitleButton
                :showBtn="false"
                :showAddNew="false"
                title="Housekeeping"
            />
        </div>

        <div class="d-flex flex-wrap gap-1 px-2 mt-2">
            <button
                v-for="tab in tabs"
                :key="tab.value"
                class="btn btn-sm"
                :class="activeTab === tab.value ? 'btn-primary' : 'btn-outline-secondary'"
                @click="onClickTab(tab.value)"
            >
                {{ tab.label }}
            </button>
        </div>

        <div class="px-2 mt-3 mb-4">
            <RunningGuest v-if="activeTab === 'running_guest'" key="running_guest" :isCheckout="true"/>
            <RunningGuest
                v-if="activeTab === 'ready_for_checkout'"
                key="ready_for_checkout"
                :isCheckout="true"
                regStatus="ready_for_checkout"
                settlementStatus=""
                emptyText="No guest ready for checkout"
                editStatus="ready_for_checkout"
            />
            <RunningGuest
                v-if="activeTab === 'on_claim'"
                key="on_claim"
                :isCheckout="true"
                regStatus="on_claim"
                settlementStatus=""
                emptyText="No guest on claim"
                editStatus="on_claim"
            />
            <HousekeepingDirty v-if="activeTab === 'dirty'"/>
        </div>
    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import HousekeepingDirty from '@/components/molecule/company/hotel/hotel-housekeeping/HousekeepingDirty.vue';
import RunningGuest from '@/components/molecule/company/hotel/hotel-frontdesk/RunningGuest.vue';
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const $route = useRoute();
const $router = useRouter();

const activeTab = ref('running_guest');
const tabs = ref([
    { label: 'Running Guest', value: 'running_guest' },
    { label: 'Ready for Checkout', value: 'ready_for_checkout' },
    { label: 'On Claim', value: 'on_claim' },
    { label: 'Dirty', value: 'dirty' },
]);

const onClickTab = (value) => {
    if (activeTab.value === value) return;
    activeTab.value = value;
    const routeQuery = Object.assign({}, $route.query, { tab: value });
    delete routeQuery.page;
    $router.replace({ path: $route.path, query: routeQuery });
};

const restoreActiveTab = () => {
    const currentTab = $route.query.tab;
    if (!currentTab) return;
    const matched = tabs.value.find(tab => tab.value === currentTab);
    if (!matched) return;
    activeTab.value = currentTab;
};

onMounted(() => {
    restoreActiveTab();
});
</script>

<style scoped>
.housekeeping-card {
    min-height: 75vh;
    padding-bottom: 4rem;
}
</style>
